export default [
    {
        path: '/advertisement/portal',
        name:'adportal',
        component:()=> import('@/views/pages/cloudx/advertisement/ad')
    }
]
  